import CatalogSearchFilter from '../catalog-search-filter/catalog-search-filter';

export default new class ButtonMore {

    constructor() {

        this.iPagination = 1;
        this.articlesWrapperClass = '.articles-page';
        this.catalogWrapperClass = '.catalog-page';
        this.articlesButtonWrapperClass = '.btn-more';

        this.bindEvents();
    }

      bindEvents() {
        var ButtonMore = this;

        $('body').on('click', this.articlesButtonWrapperClass, function (e) {

            if($(this).parents(ButtonMore.articlesWrapperClass).length > 0) {
                e.preventDefault();   
                ButtonMore.articlesPagination();
            } else if ($(e.target).closest(ButtonMore.catalogWrapperClass).length > 0) {
                e.preventDefault();
                ButtonMore.catalogPagination($(e.target));
            }
        });
    }

    articlesPagination() {
        this.iPagination++;
        $.request('onAjaxRequest', {
            update: {
                'jade-articles-list': '@.articles-page-list',
                'jade-articles-pagination': '.articles-page-pagination'
            },
            loading: '.js-preloaderOverlay',
            data: {page: this.iPagination}
        });
    }

    catalogPagination ($btnMore) {
        let checkAllCheckbox = $('.js-checkAll'),
            data = CatalogSearchFilter.reformatData(CatalogSearchFilter.getFiltersParams());

        data.page = $btnMore.attr('data-page');
        checkAllCheckbox.prop('checked', false);

        $btnMore.remove();
        $.request('OffersList::onAjaxRequest', {
            data: data,
            update: {'account-catalog-offers-result':'@.catalog-offers-list'},
            loading: '.js-preloaderOverlay',
        });
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/btn-more/btn-more.js